// The one server error a page acts on rather than just displays: the report is
// bigger than the browser can hold, and the page says so instead of freezing.
export const REPORT_TOO_LARGE_CODE = "REPORT_TOO_LARGE"

/**
 * Turns an error sentinel into a thrown Error, carrying any machine-readable
 * fields alongside the message so a caller can branch on `code`.
 */
function sentinelError({ message, code, rowCount, ceiling }) {
  const error = new Error(message)
  if (code) Object.assign(error, { code, rowCount, ceiling })
  return error
}

/**
 * Reads an NDJSON response body and returns all rows as an array.
 * Throws if the server sends an error sentinel: { __error: true, message }.
 * Rows read before the sentinel are discarded with it — a partial report must
 * never reach a chart, or its totals are wrong with nothing saying so.
 */
export async function parseNdjsonStream(response) {
  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  const rows = []
  let buffer = ""

  while (true) {
    const { done, value } = await reader.read()
    if (done) break
    buffer += decoder.decode(value, { stream: true })
    const lines = buffer.split("\n")
    buffer = lines.pop() // keep any incomplete line for the next chunk
    for (const line of lines) {
      if (!line.trim()) continue
      const parsed = JSON.parse(line)
      if (parsed.__error) throw sentinelError(parsed)
      rows.push(parsed)
    }
  }

  // flush any remaining buffered content
  if (buffer.trim()) {
    const parsed = JSON.parse(buffer)
    if (parsed.__error) throw sentinelError(parsed)
    rows.push(parsed)
  }

  return rows
}
